__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@internationalized/date", "3.12.4", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__("dd6671e3bd7c2016979b"))))));
			register("@tanstack/react-query", "5.101.4", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__("80d62b68cae7538b4281"))))));
			register("react-aria-components", "1.21.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(877)]).then(() => (() => (__webpack_require__("cb0744297bd8d9600fe7"))))));
			register("react-aria", "3.52.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(877)]).then(() => (() => (__webpack_require__("715ad142852cd72a3d49"))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__("63f14ac74ce296f77f4d"))))));
			register("react-router-dom", "6.30.2", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__("1d905a223b67ada35f1f"))))));
			register("react", "18.3.1", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__("8af190b70a6bc55c6f1b"))))));
			initExternal("6c8988c3b74fb0c8c0a4");
			initExternal("75b4900fcb4ab6327b99");
			initExternal("e6a913ad54a91c28f172");
			initExternal("f2b99248a118824e62d5");
			initExternal("9740419dec5793b440da");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};